export default class Storage {

  constructor(name) {
    this.containerName = name;
    if(!window.localStorage.getItem(name)) {
      window.localStorage.setItem(name, JSON.stringify({}));
    }
  }

  get container() {
    return JSON.parse(window.localStorage.getItem(this.containerName));
  }

  getContainer() {
    return JSON.parse(window.localStorage.getItem(this.containerName));
  }

  getItem(keyName) {
    return this.container[keyName];
  }

  setItem(keyName, value) {
    let newValue = this.container;
    newValue[keyName] = value;
    window.localStorage.setItem(this.containerName, JSON.stringify(newValue));
  }

  getObject(keyName) {
    try {
      return JSON.parse(this.getItem(keyName));
    } catch (e) {
      console.error(e);
      return null;
    }
  }

  setObject(keyName, value) {
    let newValue = this.container;
    newValue[keyName] = value;
    window.localStorage.setItem(this.containerName, JSON.stringify(newValue));
  }

  remove(keyName) {
    let newValue = this.container;
    delete newValue[keyName];
    window.localStorage.setItem(this.containerName, JSON.stringify(newValue));
  }

  clear() {
    window.localStorage.setItem(this.containerName, JSON.stringify({}));
  }

  get storageLength() {
    return Object.keys(this.container).length;
  }
}
